module.exports = __webpack_public_path__ + "img/arrow-dropdown.082de995.svg";